
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wydarzenia/[slug]/kontakt",
      function () {
        return require("private-next-pages/wydarzenia/[slug]/kontakt.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wydarzenia/[slug]/kontakt"])
      });
    }
  